import { Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";

export const WaitlistSection = () => (
  <section id="waitlist" data-testid="waitlist-cta-section" className="mx-auto max-w-6xl px-4 pb-24 sm:px-6 lg:pb-32">
    <Reveal>
      <div className="relative overflow-hidden rounded-[2.5rem] border border-emerald-500/25 bg-gradient-to-b from-emerald-500/10 via-[#131316] to-[#0A0A0C] px-6 py-16 text-center sm:px-12 lg:py-20">
        <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[36rem] -translate-x-1/2 rounded-full bg-emerald-500/15 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-16 h-56 w-56 rounded-full bg-orange-500/10 blur-3xl" />

        <p className="mono relative mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">
          Acceso anticipado
        </p>
        <h2 className="font-display relative mx-auto max-w-2xl text-3xl font-black leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Tu próximo cobro puede ser el último que persigas.
        </h2>
        <p className="relative mx-auto mt-5 max-w-xl text-base text-slate-400">
          Déjanos tu correo y sé de los primeros en activar YateAviso con 50% de descuento de por
          vida.
        </p>

        <div className="relative mx-auto mt-9 max-w-md">
          <WaitlistForm />
        </div>

        <p className="relative mt-7 inline-flex items-center gap-2 text-sm text-slate-500">
          <Users className="h-4 w-4 text-emerald-400" />
          Únete a los <span className="font-semibold text-emerald-400">+1,200 dueños de Mypes</span>
          que ya están en la lista VIP
        </p>
      </div>
    </Reveal>
  </section>
);
